import { call, all, put, select, takeEvery } from "redux-saga/effects";
import {
  fetchCompanionListByCameraSuccess,
  fetchCompanionListByCameraFailure,
  addManualCameraSuccess,
  addManualCameraFailure,
  addManualCameraSuccessResponse,
  setSelectedCameraQR,
  getFovIds,
} from "../actions";
import {
  fetchCompanionListByCamera,
  addManualCamera,
} from "../../model/cameraonboardingService";
import { types } from "../actions";
const activeSession = (state) => state.sessionReducer.activeSession;
const companionDevice = (state) =>
  state.cameraOnboardingReducer.companionDevice;
const streamInfo = (state) => state.cameraOnboardingReducer.streamInfo;
const manualAddResp = (state) =>
  state.cameraOnboardingReducer.manualApiResponse;
const manualAddStat = (state) => state.cameraOnboardingReducer.manualAddStatus;

function* handleFetchCompanionListByCamera(action) {
  try {
    const { activeSession, cameraQR } = action.payload;
    const result = yield call(
      fetchCompanionListByCamera,
      activeSession,
      cameraQR
    );
    const companionList = (result || [])?.map((item) => ({
      id: item?.id,
      name: item?.name,
    }));
    yield put(fetchCompanionListByCameraSuccess(companionList));
  } catch (error) {
    yield put(fetchCompanionListByCameraFailure(error));
  }
}

function* addManualCameraSaga(action) {
  try {
    const session = yield select(activeSession);
    const companionData = yield select(companionDevice);
    const fovData = yield select(streamInfo);
    const manualApiResponse = yield select(manualAddResp);
    const manualAddStatus = yield select(manualAddStat);
    const response = yield call(
      addManualCamera,
      companionData?.qrcode,
      fovData,
      session?.activeSession,
      manualApiResponse,
      manualAddStatus
    );
    yield put(addManualCameraSuccessResponse(response));
    yield put(addManualCameraSuccess());
  } catch (error) {
    yield put(addManualCameraFailure(error));
  }
}

function* cameraOnboardingSaga() {
  yield takeEvery(
    types.FETCH_COMPANION_LIST_BY_CAMERA_REQUEST,
    handleFetchCompanionListByCamera
  );
  yield takeEvery(types.ADD_MANUAL_CAMERA_REQUEST, addManualCameraSaga);
}

export default cameraOnboardingSaga;
